<div class="material-type" fxLayoutAlign="start center" (click)="onMaterialTypeClick(horizontalPositionOfMaterialTypeCreelPosition.isSelected, $event)">
  <div class="selected-indicator" *ngIf="canShowSelectedIndicator()"></div>
  <mat-icon *ngIf="canEditMaterialSet" class="drag-handle" svgIcon="drag-handle"></mat-icon>
  <div fxFlex>
    <div *ngIf="horizontalPositionOfMaterialTypeCreelPosition.isColor()" fxLayoutGap="16px" fxLayout="row" fxLayoutAlign="start center">
      <div class="color-preview" [style.box-shadow]="'0 3px 6px -2px' + horizontalPositionOfMaterialTypeCreelPosition.color.hexadecimalColorCode" [style.border-color]="getPreviewColorCode()">
        {{ getMaterialTypePositionViewIndex() }}
      </div>
      <vdw-ellipsis-label class="color-name" [text]="materialTypeName" matTooltipPosition="right"></vdw-ellipsis-label>
      <span class="color-rgb">
        {{ horizontalPositionOfMaterialTypeCreelPosition.color.getRgbAsCommaSeparatedValue() }}
      </span>
    </div>

    <div *ngIf="horizontalPositionOfMaterialTypeCreelPosition.isYarnType()" fxLayoutGap="16px" fxLayout="row" fxLayoutAlign="start center">
      <div class="yarn-type-preview">{{ getMaterialTypePositionViewIndex() }}</div>
      <vdw-ellipsis-label class="yarn-type-name" [text]="materialTypeName" matTooltipPosition="right"></vdw-ellipsis-label>
    </div>
  </div>
  <div fxLayoutAlign="end center" fxLayoutGap="8px">
    <button mat-icon-button (click)="decrementAmount($event)" [disabled]="!canDecrementAmount()" class="mat-icon-action-button-sm">
      <mat-icon svgIcon="subtract-small"></mat-icon>
    </button>

    <span class="material-type-amount">{{ horizontalPositionOfMaterialTypeCreelPosition.amount }}</span>

    <button mat-icon-button (click)="incrementAmount($event)" [disabled]="!canEditMaterialSet" class="mat-icon-action-button-sm">
      <mat-icon svgIcon="add-small"></mat-icon>
    </button>
  </div>
</div>
